<template>
  <div class="success">
    <div class="success-icon"></div>
    <div class="success-text">
      <p>您的问卷已提交成功</p>
      <p class="repeat-submit" v-if="isRepeatSubmit == 1" @click="handleRepeatSubmit">重新填写</p>
      <p v-else>感谢您的参与!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "success",
  props: {
    isRepeatSubmit: {
      type: [Boolean, String, Number],
      default: 0,
    },
  },
  methods: {
    handleRepeatSubmit() {
      window.location.reload();
    },
  },
};
</script>
<style scoped>
.success {
  min-height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 120px;
}
.success-icon {
  width: 87px;
  height: 93px;
  background: url("@/assets/images/success.png") no-repeat center center;
  background-size: 100% auto;
  margin-bottom: 40px;
}
.success-text {
  font-size: 30px;
  font-weight: bold;
  color: #333;
  line-height: 36px;
  text-align: center;
}
.repeat-submit {
  margin-top: 20px;
  color: #ff7730;
  font-size: 20px;
  text-decoration: underline;
  cursor: pointer;
}
</style>